<template>
	<div>
		<div id="main-content" class="welcome" role="banner">
			<p>
				This application is intended for use by anyone seeking undergraduate
				admission to one of our System schools. Here you will have the option of
				creating an account so you can start your application, leave, and return
				to submit at your convenience. Or, if you prefer, you can use our Guest
				option which will allow you to complete and submit the application in
				one sitting.
			</p>
			<p>
				<strong>PLEASE NOTE: </strong>Applicants may be required or recommended
				to submit an essay <strong>and/or</strong> resume with this application.
				We recommend reviewing the application requirements below for your
				intended application type and campus(es) and prepare materials in
				advance.
			</p>
			<h2>First Year and Transfer Applicants</h2>
			<p>
				<strong>Essay: </strong>Please submit a personal essay regarding your
				academic goals and objectives, or on a subject of personal choice.
			</p>
			<p>
				<strong>Resume: </strong>Please attach a resume of your activities
				including clubs and organizations, athletics, employment, community
				service activities, etc. This should include involvement in your school
				community and beyond.
			</p>
			<p class="mt-4">
				Essay is <strong>REQUIRED</strong> and will enhance your application
				when applying to:
			</p>
			<ul>
				<li>
					University of Maine - Nursing Program (see note)
				</li>
			</ul>
      <p>
        Note:
        <br>
        Applicants to UMaine’s Nursing program are required to submit a written
        response to essay prompts provided by the School of Nursing. For first-year
        applicants these prompts are available on the First Year Nursing Essay Prompts
        for UMaine web page located at
        <a href="https://go.umaine.edu/nursing-application-essay-fyr">https://go.umaine.edu/nursing-application-essay-fyr/</a>.
        For Transfer applicants these prompts, along with specific transfer admission
        requirements are available on the Transfer Nursing Essay Prompts for UMaine web page located
        at <a href="https://go.umaine.edu/nursing-essay-trf/">https://go.umaine.edu/nursing-essay-trf/</a>.
        Questions about the required Nursing Essay prompts should be directed to the
        University of Maine Admission office.
      </p>
			<p>
				To enhance your application you are <strong>RECOMMENDED</strong> to
				provide an essay and/or a resume if you are applying to:
			</p>
			<ul>
				<li>
					University of Maine (Orono)
				</li>
				<li>
					University of Maine at Augusta
				</li>
        <li>
          University of Maine at Farmington
        </li>
				<li>
					University of Maine at Fort Kent
				</li>
				<li>
					University of Maine at Machias
				</li>
				<li>
					University of Maine at Presque Isle
				</li>
				<li>
					University of Southern Maine
				</li>
			</ul>
			<strong
				>Acceptable formats for these documents are .txt, .docx, and
				.pdf.</strong
			>
			<h2>
				Adult Applications: (24 years of age or older)
			</h2>
			<p>
				<strong>Essay: </strong>Please submit a personal essay regarding your
				academic goals and objectives, or on a subject of personal choice.
			</p>
			<p>
				<strong>Resume: </strong>To our adult applicants, you may attach a
				resume of your life experience since leaving high school.
			</p>
			<p class="mt-4">
				To enhance your application, you are <strong>RECOMMENDED</strong> to
				provide an essay and resume if you are applying to:
			</p>
			<ul>
				<li>
					University of Maine (Orono)
				</li>
				<li>
					University of Maine at Augusta
				</li>
				<li>
					University of Maine at Farmington
				</li>
				<li>
					University of Maine at Fort Kent
				</li>
				<li>
					University of Maine at Machias
				</li>
				<li>
					University of Maine at Presque Isle
				</li>
				<li>
					University of Southern Maine
				</li>
			</ul>
			<strong
				>Acceptable formats for these documents are .txt, .docx, and
				.pdf.</strong
			>
			<p>
				For specific questions on application requirements of the individual
				campuses, please visit the following webpages:
			</p>
			<ul>
				<li>
					<a
						class="ums-text-primary"
						href="https://www.uma.edu/admission/apply/"
						>UMA Application Requirements</a
					>
				</li>
				<li>
					<a
						class="ums-text-primary"
						href="https://www.umf.maine.edu/admissions-aid/first-year-students-freshmen/"
						>UMF Application Requirements</a
					>
				</li>
				<li>
					<a
						class="ums-text-primary"
						href="https://www.umfk.edu/admissions/apply/"
						>UMFK Application Requirements</a
					>
				</li>
				<li>
					<a class="ums-text-primary" href="https://machias.edu/admissions/"
						>UMM Application Requirements</a
					>
				</li>
				<li>
					<a class="ums-text-primary" href="https://go.umaine.edu/apply/"
						>UMaine Application Requirements</a
					>
				</li>
				<li>
					<a
						class="ums-text-primary"
						href="https://www.umpi.edu/admissions/how-to-apply/"
						>UMPI Application Requirements</a
					>
				</li>
				<li>
					<a class="ums-text-primary" href="https://usm.maine.edu/apply"
						>USM Application Requirements</a
					>
				</li>
			</ul>
		</div>
		<div class="mx-auto" style="width: 90px">
			<b-button variant="primary" @click="continue_click()">Continue</b-button>
		</div>
	</div>
</template>

<script>
import bowser from "bowser";

export default {
	methods: {
		continue_click() {
			this.$router.push("/intro");
		}
	},
	mounted() {
		if (bowser.msie) {
			this.$store.dispatch("add_alert", {
				variant: "warning",
				msg:
					"Internet Explorer is not a supported by this application. If you are having issues, please switch browsers to Chrome, FireFox or Edge."
			});
		}
	},
	destroyed() {
		this.$store.commit("clear_alerts");
	}
};
</script>

<style scoped></style>
